import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { LogisticService } from '../../../services/logistic.service';

@Component({
  selector: 'tt-product-prices',
  templateUrl: './product-prices.component.html',
  styleUrls: ['./product-prices.component.css']
})
export class ProductPricesComponent implements OnInit {
    prodId;

    public selectedBgPriceType: string = 'PRICELIST';

    public setting?: Setting;

    public selectListProductSizes: Item[] = [];

    public selectListPriceGroups: PriceGroupItem[] = [];

    public itemsListRelatedToPriceGroups: Item[] = [];

    public itemsListRelatedToProductSizes: Item[] = [];

    public approving = false;

    public rollbacking = false;

    public refreshingPriceGroups = false;

    public priceGroupButtons: FormButton[] = [
        { id: 'list', type: 'primary', icon: 'fa fa-solid fa-bars', goto: 'colorgrps' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadSetting() {
        if (!!this.prodId) {
            this.setting = (await this.datatask.Post(643, { prod_id: this.prodId }))[0];
        }
    }

    private async loadProductSizes() {
        if (!!this.prodId) {
            this.selectListProductSizes = await this.logistic.getProductSizes(this.prodId);
        }
    }

    private async loadPriceGroups() {
        if (!!this.setting) {
            this.selectListPriceGroups = await this.datatask.Post(645, { prodsize_keyno: this.setting.prodsize_keyno });
        }
    }

    private async loadRelatedToPriceGroups() {
        if (!!this.setting) {
            this.itemsListRelatedToPriceGroups = await this.datatask.Post(646, this.setting);
        }
    }

    private async loadRelatedToProductSizes() {
        if (!!this.setting) {
            this.itemsListRelatedToProductSizes = await this.datatask.Post(647, this.setting);
        }
    }

    private async retrieveProductPriceSettings() {
        if (!!this.setting) {
            const response = (await this.datatask.Post(644, { prodsize_keyno: this.setting.prodsize_keyno }))[0];

            this.setting.pricegrp_keyno = response?.pricegrp_keyno;

            if (!!this.setting.pricegrp_keyno) this.loadPriceGroups();
        }
    }

    public async approveChanges() {
        if (!!this.itemsListRelatedToPriceGroups) {
            try {
                this.approving = true;

                await this.datatask.Post(659, {
                    way: 'APPROVE',
                    listitems: this.itemsListRelatedToPriceGroups
                });

                this.loadRelatedToPriceGroups();
            } finally {
                this.approving = false;
            }
        }
    }

    public async rollbackChanges() {
        if (!!this.itemsListRelatedToPriceGroups) {
            try {
                this.rollbacking = true;

                await this.datatask.Post(659, {
                    way: 'ROLLBACK',
                    listitems: this.itemsListRelatedToPriceGroups
                });

                this.loadRelatedToPriceGroups();
            } finally {
                this.rollbacking = false;
            }
        }
    }

    public async refreshPriceGroupsChanges() {
        if (!!this.setting) {
            try {
                this.refreshingPriceGroups = true;

                const response = (await this.datatask.Post(3857, this.setting))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.loadSetting();
                }
            } finally {
                this.refreshingPriceGroups = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'prodsize_keyno':
                if (!!this.setting?.prodsize_keyno) {
                    Promise.all([
                        this.retrieveProductPriceSettings()
                    ]).then(() => {
                        this.loadRelatedToProductSizes();
                        this.loadRelatedToPriceGroups();

                        Promise.resolve();
                    });
                }
                break;
            case 'pricegrp_keyno':
                if (!!this.setting?.pricegrp_keyno) {
                    this.loadRelatedToPriceGroups();
                }
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadProductSizes();

        Promise.all([
            this.loadPriceGroups()
        ]).then(() => {
            this.loadRelatedToPriceGroups();
            this.loadRelatedToProductSizes();

            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    prodsize_keyno: string;
    pricegrp_keyno: string;
    show_prodsize_keyno: string;
    show_pricegrp_keyno: string;
    show_approve_prices: string;
    show_setting: string;
    prod_id: string;
}

interface PriceGroupItem {
    pricegrp_keyno: number;
    pricegrp_name: string;
    orderby: number;
}
